
  export enum PUBLICLINK{
    HOME = '/',
    ABOUT = '/about',
    CONTACT = '/contact',
    BLOG = '/blog',
    FAQS='/faqs',
    SERVICES="/services",
    CONSULTATION="/consultation",
    PROJECTS='/projects',
    PORTFOLIOS='/projects/portfolio',
    INVESTMENTS='/projects/properties?type=INVESTMENTS',
    LISTINGS='/projects/properties?type=LISTINGS',
    DASHBOARD='/dashboard/auth',
    PRIVACY='/privacy',
  }

  export enum  DASHBOARDLINKS {
    DASHBOARD = '/dashboard',
    PORTFOLIOVIEW = '/dashboard/portfolio/view',
    PORTFOLIO = '/dashboard/portfolio',
    PORTFOLIOCREATE = '/dashboard/portfolio/create',
    PROPERTIESCREATE = '/dashboard/properties/create',
    PROPERTIES = '/dashboard/properties',
    PROPERTIESPREVIEW = '/dashboard/properties/preview',
    PROPERTIESVIEW = '/dashboard/properties/view',
    INVESMENTVIEW = '/dashboard/investments/view',
    INVESTMENTPREVIEW = '/dashboard/investments/preview',
    ADDINVESTMENT = '/dashboard/investments/create',
    LISTINGSVIEW = '/dashboard/listings/view',
    LISTINGS = '/dashboard/listings',
    LISTINGPREVIEW = '/dashboard/listings/preview',
    ADDLISTING = '/dashboard/listings/create',
    SENDCONFIRMATION = '/dashboard/consultations/emailconfirm',
    SCHEDULECONSULTATION = '/dashboard/consultations/create',
    INVESTMENTS = '/dashboard/investments',
    CONSULTATIONS = '/dashboard/consultations',
    CONSULTATIONEMAILCOMPOSE = '/dashboard/consultations/emailcompose',
    PREVIEWCONSULTATIONEMAIL = '/dashboard/consultations/preview',
    USERS = '/dashboard/users',
    SETTINGS = '/dashboard/settings',
    LOGIN = '/dashboard/auth?type=login',
    BLOGS = '/dashboard/blogs',
    CREATEBLOG=`${BLOGS}/create`,
    CREATINGBLOG = '/dashboard/blogs/create',
    PREVIEWBLOG = '/dashboard/blogs/preview',
    PROPERTYLISTING = '/projects/properties/'
  }
  
  export const AppLinks = {
    DASHBOARD: DASHBOARDLINKS,
    PUBLIC: PUBLICLINK,
  };